import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import styled, { css } from 'styled-components';

export const WrapperStyled = styled.div(
    ({ theme }) => css`
        margin-top: ${theme.gap.small};
    `,
);

export const GroupWrapperStyled = styled.div`
    margin-bottom: 30px;
`;

export const GroupHeaderStyled = styled.h5(
    ({ theme }) => css`
        padding-bottom: 10px;
        margin-bottom: 10px;

        border-bottom: 1px solid ${theme.color.gray};
    `,
);

export const ListWrapperStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const BrandItemStyled = styled(ExtendedNextLink)(
    ({ theme }) => css`
        padding: 10px 12px;
        margin-right: 10px;
        margin-bottom: 10px;

        background-color: ${theme.color.gray};
        color: ${theme.color.primary};
        border-radius: 23px;
        text-decoration: none;
        font-weight: 500;

        &:hover {
            text-decoration: underline;
        }
    `,
);
